import { useEffect } from 'react'
import { useMedia } from './useMedia'

/** Inclinacao 3D suave nos cartoes marcados com data-tilt. */
export function useTilt() {
  const { reduced, isTouch } = useMedia()

  useEffect(() => {
    if (reduced || isTouch) return
    const cartoes = Array.from(document.querySelectorAll<HTMLElement>('[data-tilt]'))
    const limpezas: Array<() => void> = []

    cartoes.forEach((cartao) => {
      let quadro: number | null = null

      const aoMover = (e: MouseEvent) => {
        if (quadro) return
        quadro = window.requestAnimationFrame(() => {
          const r = cartao.getBoundingClientRect()
          const px = (e.clientX - r.left) / r.width - 0.5
          const py = (e.clientY - r.top) / r.height - 0.5
          cartao.style.transform =
            `perspective(1100px) rotateY(${(px * 4).toFixed(2)}deg) ` +
            `rotateX(${(-py * 4).toFixed(2)}deg) translateY(-5px)`
          quadro = null
        })
      }

      const aoSair = () => {
        // A transicao so existe na volta: na ida ela brigaria com o rAF e o
        // cartao ficaria arrastando atras do mouse.
        cartao.style.transition = 'transform .6s cubic-bezier(.22,1,.36,1)'
        cartao.style.transform = ''
        window.setTimeout(() => { cartao.style.transition = '' }, 600)
      }

      cartao.addEventListener('mousemove', aoMover)
      cartao.addEventListener('mouseleave', aoSair)
      limpezas.push(() => {
        cartao.removeEventListener('mousemove', aoMover)
        cartao.removeEventListener('mouseleave', aoSair)
        if (quadro) window.cancelAnimationFrame(quadro)
      })
    })

    return () => limpezas.forEach((f) => f())
  }, [reduced, isTouch])
}
